import React, { useEffect, useState } from 'react';

/** Mensagens que rodam enquanto a IA monta a rotina (anamnese e chat). */
const MENSAGENS = [
  'Lendo seu perfil de pele...',
  'Vendo os melhores produtos pra você...',
  'Tirando o que pode te irritar...',
  'Conferindo os ativos que combinam entre si...',
  'Pensando na ordem certa das etapas...',
  'Ajustando a rotina da manhã...',
  'Ajustando a rotina da noite...',
  'Evitando misturas que brigam na sua pele...',
  'Dando os retoques finais...',
];

/** Fora do componente de propósito: assim a última mensagem também não se
 *  repete entre dois carregamentos seguidos, e não só dentro de um. */
let ultimoIndice = -1;

export function proximaMensagem(): string {
  const disponiveis = MENSAGENS.filter((_, i) => i !== ultimoIndice);
  const escolhida = disponiveis[Math.floor(Math.random() * disponiveis.length)];
  ultimoIndice = MENSAGENS.indexOf(escolhida);
  return escolhida;
}

interface AiGeneratingLoaderProps {
  /** Largura/espaçamento ficam com quem usa — o loader só preenche o espaço. */
  className?: string;
}

/**
 * Barrinha de progresso + mensagem rotativa para as esperas da IA.
 * ponytail: a barra é animação CSS (não há progresso real vindo do backend);
 * trocar por progresso medido se um dia a geração virar streaming.
 */
export default function AiGeneratingLoader({ className = '' }: AiGeneratingLoaderProps) {
  const [mensagem, setMensagem] = useState(proximaMensagem);

  useEffect(() => {
    const id = setInterval(() => setMensagem(proximaMensagem()), 3000);
    return () => clearInterval(id);
  }, []);

  return (
    <div role="status" className={`w-full flex flex-col items-center gap-2.5 ${className}`}>
      <div className="w-full h-1.5 bg-nude-100 dark:bg-gray-700 rounded-full overflow-hidden">
        <div className="h-full rounded-full bg-gradient-to-r from-blush-400 to-lavender-400 animate-ai-progress" />
      </div>
      <p
        key={mensagem}
        className="text-sm text-nude-500 dark:text-gray-400 text-center animate-fade-in"
      >
        {mensagem}
      </p>
    </div>
  );
}
